import React from 'react';
import { ReactSVG } from 'react-svg';
import cx from 'classnames';
import styles from './Icon.module.scss';

/** s = 16px (beside 12-14px text), m = 20px (fields, buttons - default), l = 24px (header, category bar) */
export enum IconSize {
  's' = 's',
  'm' = 'm',
  'l' = 'l',
}

export type IconProps = {
  // An svg from src/assets/icons, imported as a URL
  src: string;
  size?: IconSize;
  // Spoken name for an icon that stands on its own. An icon next to its
  // text is decoration and stays hidden from assistive tech.
  label?: string;
  className?: string;
};

// The one way to draw an icon (design audit, section 4.6): a square box of
// s / m / l with the svg filling it in `currentColor`, so the icon takes the
// text colour of its parent and a single hover rule recolours both. The
// icons are drawn on a 24px grid with a 1.5px line (src/assets/icons/README.md).
// The wrapper is a span, so an Icon can sit inside a <button> or a <p>.
const Icon = ({ src, size = IconSize.m, label, className }: IconProps) => (
  <ReactSVG
    src={src}
    wrapper="span"
    className={cx(styles.icon, styles[size], className)}
    role={label ? 'img' : undefined}
    aria-label={label}
    aria-hidden={label ? undefined : true}
  />
);

export default Icon;
